import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/** Better Auth client. The API lives on the same origin under /api/auth. */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  // The login page handles the second step itself (it reads twoFactorRedirect).
  plugins: [twoFactorClient()],
});
